import { render, staticRenderFns } from "./OtherIncomeForm.vue?vue&type=template&id=d3d1d27c"
import script from "./OtherIncomeForm.vue?vue&type=script&lang=js"
export * from "./OtherIncomeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports